import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatChatspotApiMessage } from 'chatspot-core/messages/api/formatChatspotApiMessage';
import { getThreadPage } from '../api/threadsApi';
export const getThreadMessagesPage = createAsyncThunk('threads/getThreadMessagesPage', ({
  id,
  limit,
  offset
}) => {
  return getThreadPage({
    id,
    limit,
    offset
  }).then(response => ({
    hasMore: response.messages.hasMore,
    offset: response.messages.offset,
    results: response.messages.results.map(apiMessage => formatChatspotApiMessage(apiMessage, apiMessage.source || 'CHAT'))
  }));
});